import AbstractComponent from './AbstractComponent';
import Logger from '../utils/Logger';
import { addEventListener } from '../utils/EventUtils';

export default class ContentFilters extends AbstractComponent {
    constructor(...args) {
        Logger.log('ContentFilters->constructor()');
        super(...args);

        this.classname = 'c-content-filters';
        this.initDomElements();
        this.addEventListeners();
    }

    initDomElements() {
        this.$select = this.$el.querySelector(this.getSelector('__dropdown__select'));
    }

    addEventListeners() {
        if (this.$select) {
            addEventListener(this.$select, 'change', this.selectChanged.bind(this));
        }
    }

    selectChanged(e) {
        const value = e.target.value;
        if (value) {
            window.location.href = value;
        }
    }

    destroy() { }
}